export const SHOW_LOADING = "SHOW_LOADING";
export const HIDE_LOADING = "HIDE_LOADING";

export const FETCH_PROJECT_CATE = "FETCH_PROJECT_CATE";
export const FETCH_PROJECT_CATE_SUCCESS = "FETCH_PROJECT_CATE_SUCCESS";
export const FETCH_PROJECT_CATE_FAILED = "FETCH_PROJECT_CATE_FAILED";

export const FETCH_NEWS_CATE = "FETCH_NEWS_CATE";
export const FETCH_NEWS_CATE_SUCCESS = "FETCH_NEWS_CATE_SUCCESS";
export const FETCH_NEWS_CATE_FAILED = "FETCH_NEWS_CATE_FAILED";

export const FETCH_SLIDER = "FETCH_SLIDER";
export const FETCH_SLIDER_SUCCESS = "FETCH_SLIDER_SUCCESS";
export const FETCH_SLIDER_FAILED = "FETCH_SLIDER_FAILED";

export const FETCH_PROJECT_BY_ID = "FETCH_PROJECT_BY_ID";
export const FETCH_PROJECT_BY_ID_SUCCESS = "FETCH_PROJECT_BY_ID_SUCCESS";
export const FETCH_PROJECT_BY_ID_FAILED = "FETCH_PROJECT_BY_ID_FAILED";

export const FETCH_ALL_PROJECT = "FETCH_ALL_PROJECT";
export const FETCH_ALL_PROJECT_SUCCESS = "FETCH_ALL_PROJECT_SUCCESS";
export const FETCH_ALL_PROJECT_FAILED = "FETCH_ALL_PROJECT_FAILED";

export const FETCH_NEWS = "FETCH_NEWS";
export const FETCH_NEWS_SUCCESS = "FETCH_NEWS_SUCCESS";
export const FETCH_NEWS_FAILED = "FETCH_NEWS_FAILED";

export const FETCH_NEWS_BY_ID = "FETCH_NEWS_BY_ID";
export const FETCH_NEWS_BY_ID_SUCCESS = "FETCH_NEWS_BY_ID_SUCCESS";
export const FETCH_NEWS_BY_ID_FAILED = "FETCH_NEWS_BY_ID_FAILED";

export const FETCH_NEWS_CONTENT = "FETCH_NEWS_CONTENT";
export const FETCH_NEWS_CONTENT_SUCCESS = "FETCH_NEWS_CONTENT_SUCCESS";
export const FETCH_NEWS_CONTENT_FAILED = "FETCH_NEWS_CONTENT_FAILED";

// Hien code 

export const FETCH_ABOUT_US_CONTENT = "FETCH_ABOUT_US_CONTENT";
export const FETCH_ABOUT_US_CONTENT_SUCCESS = "FETCH_ABOUT_US_CONTENT_SUCCESS";
export const FETCH_ABOUT_US_CONTENT_FAILED = "FETCH_ABOUT_US_CONTENT_FAILED";

export const FETCH_SHARED_LIST = "FETCH_SHARED_LIST";
export const FETCH_SHARED_LIST_SUCCESS = "FETCH_SHARED_LIST_SUCCESS";
export const FETCH_SHARED_LIST_FAILED = "FETCH_SHARED_LIST_FAILED";

export const FETCH_DETAIL_SHARED = "FETCH_DETAIL_SHARED";
export const FETCH_DETAIL_SHARED_SUCCESS = "FETCH_DETAIL_SHARED_SUCCESS";
export const FETCH_DETAIL_SHARED_FAILED = "FETCH_DETAIL_SHARED_FAILED";
// ------------step 1-------------------
export const SET_DISPLAY_SEARCH = "SET_DISPLAY_SEARCH";

export const FETCH_GENERAL_CONTENT = "FETCH_GENERAL_CONTENT";
export const FETCH_GENERAL_CONTENT_SUCCESS = "FETCH_GENERAL_CONTENT_SUCCESS";
export const FETCH_GENERAL_CONTENT_FAIL = "FETCH_GENERAL_CONTENT_FAIL";

export const SAVE_CONTACT  = 'SAVE_CONTACT';
export const SAVE_CONTACT_SUCCESS  = 'SAVE_CONTACT_SUCCESS';
export const SAVE_CONTACT_FAILED  = 'SAVE_CONTACT_FAILED';

export const SET_KEY_SEARCH = 'SET_KEY_SEARCH';

export const FETCH_SEARCH = "FETCH_SEARCH";
export const FETCH_SEARCH_SUCCESS = "FETCH_SEARCH_SUCCESS";
export const FETCH_SEARCH_FAILED = "FETCH_SEARCH_FAILED";